import { ComponentSchema } from "./types";

// ═══════════════════════════════════════════════════════════════
// Spacing: Margins & Padding
// ═══════════════════════════════════════════════════════════════
// ═══════════════════════════════════════════════════════════════
// Spacing: Margins & Padding (Unified Visual Control)
// ═══════════════════════════════════════════════════════════════
export const SpacingSchema: ComponentSchema = {
    padding: { type: "spacing", label: "الحواف والمسافات", defaultValue: { top: 0, right: 0, bottom: 0, left: 0, unit: "px" } },
    margin: { type: "spacing", label: "الهوامش الخارجية", defaultValue: { top: 0, right: 0, bottom: 0, left: 0, unit: "px" } },
};

// ═══════════════════════════════════════════════════════════════
// Dimensions: Width, Height (Unified Control)
// ═══════════════════════════════════════════════════════════════
export const DimensionsSchema: ComponentSchema = {
    dimensions: {
        type: "dimensions",
        label: "الأبعاد",
        defaultValue: {
            width: { value: 0, unit: "auto" },
            height: { value: 0, unit: "auto" }
        }
    },
};

// ═══════════════════════════════════════════════════════════════
// Backgrounds & Effects
// ═══════════════════════════════════════════════════════════════
export const BackgroundSchema: ComponentSchema = {
    backgroundColor: { type: "color", label: "لون الخلفية", defaultValue: "transparent" },
    opacity: { type: "slider", label: "الشفافية", defaultValue: 1, sliderConfig: { min: 0, max: 1, step: 0.05 } },
    shadow: { type: "shadow", label: "الظل", defaultValue: "none" },
};

// ═══════════════════════════════════════════════════════════════
// Border & Radius
// ═══════════════════════════════════════════════════════════════
export const BorderSchema: ComponentSchema = {
    border: { type: "border", label: "الحدود", defaultValue: { width: 0, style: "solid", color: "#000000", radius: 0 } },
};

// ═══════════════════════════════════════════════════════════════
// The Master "Universal Style" Mixin
// ═══════════════════════════════════════════════════════════════
export const UniversalStyleSchema: ComponentSchema = {
    ...SpacingSchema,
    ...DimensionsSchema,
    ...BackgroundSchema,
    ...BorderSchema,
};
